// import React from 'react';

//export部分
function ResetAndSubmit() {
    return(
        <div className="reset-and-submit form__reset-and-submit"> 
            <div className="reset-and-submit__inner">
                <input type="reset" className="reset-and-submit__reset" value="クリア" />
                <input type="submit" className="reset-and-submit__submit" value="検索" />
            </div>
        </div>
    );
}

export default ResetAndSubmit;